import { all, fork } from 'redux-saga/effects';

import listenDateToggled from './listenDateToggled';
import listenLoad from './listenLoad';
import listenSetRange from './listenSetRange';

export default function* occupationsSaga() {
  yield all([fork(listenLoad), fork(listenDateToggled), fork(listenSetRange)]);
}
